module.exports = __webpack_public_path__ + "images/graphic-header-2@2x_68d4dfbbd34377ab352c4ea6939b8669.png";